module.exports = __webpack_public_path__ + "img/iddigo.ca715c50.svg";